export default __webpack_public_path__ + "static/media/quiz.fb6443d0.svg";